

























	import { Vue, Component, Prop, EnumsService, EnumsFilter, GroupFilter, GroupService, tlISOTimeWithoutSecondToLocalString, Watch } from "../../Infrastructure/CorBase/CoreBase";
	//VaPTODO - proc se nedela import storu z corebase????
	import storeGlobal from "../../Infrastructure/CorBase/StoreBase";

	//POPIS
	//1) chci nacist kolekci z tabulky enums:  enumGroup="ENU_COR_CommunicationMedium_MediumType"
	//2) pouzit nacteni podle servis : useService="workingGroup"  -- zatim jen dve asi zrusitf
	//3) groups je potreba jen useOwnEnums=true
	//4) vlastni kolekce useOwnEnumsSend=true a  useOwnEnumsSendArray - zde vlastni kolekce

	//VZOR
					//<base-tl-input v-model="formData.type"
					//						 :textLabelWidth="labelWidth"
					//						 :inputWidth="inputWidth"
					//						 :readonly.boolean="updateMode"
					//						 textLabel="Druh"
					//						 :useEnum=true
					//						 :useOwnEnumsSend=true
					//						 :useOwnEnumsSendArray="types"
					//						 @changeselected="formData.type = $event " />

	
		//types = [
		//	{ value: 0, text: 'Zadat datum' },
		//	{ value: 1, text: 'Dny v týdnu' }];

	@Component
	export default class BaseTLDropDownList extends Vue {

		@Prop({ type: String, required: false, default: "id" }) id?: string;//id
		@Prop({ type: String, required: false, default: "150" }) sizeMenu?: string; //velikost menu
		@Prop({ required: false, default: null }) selected: any;  //vyběr
		@Prop(Boolean) readonly!: boolean;	
		@Prop({ type: String, required: false, default: "" }) design?: string; //design

        @Prop({ type: Boolean, required: false, default: false }) usePlaceholder?: boolean; //zobrazit placeholdera
        @Prop({ type: String, required: false, default: "" }) placeholder!: string;//info popisek

		@Prop({ type: Boolean, required: false, default: false }) showInTable?: boolean; //v tabulce - nezobrazuje se label
		@Prop({ type: Boolean, required: false, default: false }) addItemAll?: boolean; //přidání položky Vše, když použiju enumGroup a chci ještě mit možnost vše

		@Prop({ type: Boolean, required: false, default: false }) firstEmpty?: boolean; //nastaveni prvni vyberu z ciselniku je prazdný
		@Prop({ type: Number, required: false, default: "-1" }) firstEmptyValue?: String | Number | null; //hodnota pro prvni vyberu z ciselniku je prazdný
		@Prop({ type: String, required: false, default: "" }) firstEmptyLabel?: String; //text pro prvni vyberu z ciselniku je prazdný
		@Prop({ type: String, required: false, default: "" }) enumGroup?: string; //typ co se ma nacist - pouze groups tak pouzit useOwnEnums- tady dát např. ENU_SHP_WorkingGroup_Centre
		@Prop({ type: Boolean, required: false, default: false }) enumIdSameName?: boolean; //id je stejne jako nazev
		@Prop({ type: Boolean, required: false, default: false }) useForFilter?: boolean; //pouziti pro filtr, value se naplni jako name

		@Prop({ type: Boolean, required: false, default: false }) required?: boolean; //povinné pole
		@Prop({ type: Boolean, required: false, default: false }) autofocus?: boolean; //focus

		@Prop({ type: Boolean, required: false, default: false }) useOwnEnums?: boolean; //když nechci dotahovat z ENUMS, ale poslat tam vlastni kolekci (zatim jen group )
		@Prop({ type: Boolean, required: false, default: false }) useOwnEnumsSend?: boolean; //když nechci dotahovat z ENUMS, ani groups - rovnou poslu kolekci dole vzor
		@Prop({ type: Array, required: false }) useOwnEnumsSendArray!: any[]; //tady vlastní kolekce  - lze dynamicky měnit

		@Prop({ type: Array, required: false }) useOwnOrder!: any[]; //vlastní řazení

		@Prop({ type: String, required: false, default: "" }) useService?: string; //chci načíst z nějaké tabulky - tohle není optimální
		@Prop({  required: false, default: "" }) notInChoiceId?: any; //id které nechci v seznamu - převážně sám sebe
		@Prop({ type: String, required: false, default: "" }) objectType?: string; //typ objektu, pro ktery se nacitaji skupiny - udelano kvuli pravum, aby se zobrazila spravna mnozina groups podle nastaveni prav
		
		enumsService: EnumsService = new EnumsService();
		groupService: GroupService = new GroupService();

		placeHoldeText() {
			return "--"+this.placeholder+"--";
		}


		showPlaceHolder() {			
            return this.usePlaceholder && (this.selectedItem == undefined || this.selectedItem == '' || this.selectedItem == null || this.selectedItem == this.firstEmptyValue);
		}

		enums: any[] = [];
	
		itemsDropDown: any[] = [];

		created() {
			this.initEnums(this.enumGroup);
		}

		optionsItems() {
			if (this.useOwnEnumsSend == true) {
				return this.useOwnEnumsSendArray;
			}
			return this.itemsDropDown;
		}

		initEnums(identifEnum: string | null = '') {
			this.itemsDropDown = [];
			//HegTODO - najit lepsi cestu jak posilat groups nadrizene

			if (this.useOwnEnums == true) {
				if (this.enums.length == 0) {
					let groupFilter: GroupFilter = new GroupFilter(null, null, storeGlobal.state.idTenant, this.objectType);
					this.groupService.getAllByFilter(groupFilter).then((response) => {
						this.enums = response.data;
						//prazdny prvek
						if (this.firstEmpty) {
							this.itemsDropDown.push({ value: this.firstEmptyValue, text: this.firstEmptyLabel });
						}
						for (var i = 0; i < this.enums.length; i++) {
							this.itemsDropDown.push({ value: this.enums[i].id, text: this.enums[i].name });
						}
					});
				}
			}
			else if (this.useOwnEnumsSend == true) //zde vlastní kolekce musí být vyplneno useOwnEnumsSendArray
			{
				for (var i = 0; i < this.useOwnEnumsSendArray.length; i++) {
				
					this.itemsDropDown.push({ value: this.useOwnEnumsSendArray[i].value, text: this.useOwnEnumsSendArray[i].text });
				}			
			}


  //HEg TODO nevím jak optimalneji poslat tu koleci
			//else if (this.useService != '') //zde servisu
			//{
				
			//	if (this.useService == 'workingGroup') {
			//		let workingGroupService: WorkingGroupService = new WorkingGroupService();
			//		let workingGroupFilter: WorkingGroupFilter = new WorkingGroupFilter(this.$store.state.idTenant, false);
			//		workingGroupService.getAllByFilter(workingGroupFilter).then((response) => {						

			//			for (var i = 0; i < response.data.length; i++) {
			//				if (response.data[i].id != this.notInChoiceId)
			//				this.itemsDropDown.push({ value: response.data[i].id, text: response.data[i].name });
			//			}						
			//		});
			//	}
			//	if (this.useService == 'connection') {
			//		let connectionService: ConnectionService = new ConnectionService();
			//		let connectionFilter: ConnectionFilter = new ConnectionFilter(null,this.$store.state.idTenant);
			//		connectionService.getAllByFilter(connectionFilter).then((response) => {					

			//			for (var i = 0; i < response.data.length; i++) {
			//				let name = response.data[i].name + ' (' + tlISOTimeWithoutSecondToLocalString(response.data[i].departureTime) + " - " + tlISOTimeWithoutSecondToLocalString(response.data[i].arrivalTime) + ")";
			//				this.itemsDropDown.push({ value: response.data[i].id, text: name });
			//			}						
			//		});
			//	}

			//}
			else {
				let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, identifEnum, false);
				this.enumsService.getAllByFilter(enumsFilter).then((response) => {
					this.enums = response.data;
					//vlastni setrideni
					if (this.useOwnOrder != undefined) {			
						var actEnum = [];
						for (var i = 0; i < this.useOwnOrder.length; i++) {
							for (var a = 0; a < this.useOwnOrder.length; a++) {
								if (this.useOwnOrder[a] == i) {
									actEnum.push(this.enums[a]);
									break;
								}
							}
						}
						this.enums = actEnum;
					}

					if (this.addItemAll) {
						this.itemsDropDown.push({ value: 0, text: 'vše' });
					}

                    if (this.firstEmpty) {
                        this.itemsDropDown.push({ value: this.firstEmptyValue, text: this.firstEmptyLabel, key: 'nothnig' });
                    }

					for (var i = 0; i < this.enums.length; i++) {
						if (this.useForFilter) {						
							this.itemsDropDown = this.itemsDropDown.sort((a, b ) => { if(a.text > b.text ) { return 1; } else if (a.text < b.text) { return -1 } else { return 0;}});
							this.itemsDropDown.push({ value: this.enums[i].name, text: this.enums[i].name, key: this.enums[i].identifier });
						}
						else {
							if (this.enumIdSameName == true) {
                                this.itemsDropDown.push({ value: this.enums[i].name, text: this.enums[i].name, key: this.enums[i].identifier });
							}
							else {
								this.itemsDropDown.push({ value: this.enums[i].id, text: this.enums[i].name, key: this.enums[i].identifier });
							}
						}
					}
					this.$emit('items', this.itemsDropDown);
				});
			}
		
		}



		set selectedItem(value: any) {	
			this.$emit('changeselected', value);
		}
		get selectedItem() {		
			return this.selected;
		}

		//vzor pro  useOwnEnumsSendArray
		itemsTest = [
			{ value: 1, text: 'Prvni' },
			{ value: 2, text: 'Druhy' },
			{ value: 3, text: 'Treti' },
			{ value: 4, text: 'Ctvrty' }];


		validate() {		

			if ( this.required == false || this.readonly) {
				return null;
			}

			let result: boolean = this.selectedItem != '' && this.selectedItem != this.firstEmptyValue && this.selectedItem != null;
	
			this.$emit('isCorrect', result);		
			return result;
		}

		styleMenu() {
			return " width: " + this.sizeMenu + "px;";
		}

		//HegToDo - jak nastavit i menu stejnou velikost
		styleMenuItem() {
			return " width: " + this.sizeMenu + "px;";
		}

		//načtení stylu
		get inputClass() {
			return {
                "inputDetailDropDownFilterBlack": this.design == 'filterTop',
				"inputDetailDropDownFilter": this.design == 'filterTop',
				"inputDetailDropDownGrid": this.design == 'grid',
				"inputDetailDropDownIsEditBlack": !this.readonly && this.design == 'blackDesign',
				"inputDetailDropDownIsEditWhite": !this.readonly && this.design == 'white',
                "custom-select-white": this.design == 'blackDesign',
				"inputDetailDropDownNoEdit": this.readonly && this.design == '',
				"inputDetailDropDownIsEdit": !this.readonly && this.design == ''

				//původní
				//"form-select": false,
				//"drop-down-list ": true,				
				//" drop-down-list-table": this.showInTable
			};
		}

		dropDownText() {
			let result = this.selectedItem;

			return result;
		}

	}
